import _ from "lodash"

export default function handleInitialValues(data = null, editMode) {
  if (!data) {
    const name = `custom_${Date.now()}`
    const defaultInitValues = {
      field_name: name,
      field_name_report: name,
      description: "",
      field_description: "",
      field_label: "",
      field_type: "text",
      field_type_subtype: "",
      field_options: [],
      field_required: false,
      field_required_msg: "",
      field_conditional: false,
      field_conditional_key: "",
      field_conditional_value: "",
      field_number_min: 0,
      field_number_max: 1,
    }
    return defaultInitValues
  }

  const handleInitialFieldOptions = () => {
    const { field_options } = data.cloneField
    if (_.isEmpty(field_options)) return []
    return _.map(field_options, (option) => option.value)
  }
  const handleConditionalData = (property) => {
    const parseFieldConditional = () => {
      try {
        const parseField = JSON.parse(data.cloneField.field_conditional)
        return parseField
      } catch (error) {
        return {}
      }
    }
    const field_conditional = parseFieldConditional()
    const getPairs = _.toPairs(field_conditional)
    if (_.isEmpty(getPairs)) return ""
    switch (property) {
      case "key":
        return getPairs[0][0]
      case "value":
        return _.isArray(getPairs[0][1]) ? getPairs[0][1] : [getPairs[0][1]]
      default:
        return ""
    }
  }

  const handleIsConditional = () => {
    const slitType = _.split(data.cloneField.field_type, "_", 1)
    return slitType[0] === "conditional"
  }
  const handleFieldTypeIfConditional = () => {
    const splitType = _.split(data.cloneField.field_type, "_")
    if (splitType[0] === "conditional") {
      return splitType.slice(1).join("_")
    }
    return data.cloneField.field_type
  }

  return {
    field_name: editMode ? data.cloneField.field_name : data.cloneField.idField,
    description: data.cloneField.description,
    field_description: data.cloneField.field_description,
    field_name_report: data.cloneField.field_name_report,
    field_label: data.cloneField.field_label,
    field_type: handleFieldTypeIfConditional(),
    field_type_subtype: data.cloneField.field_type_subtype || "",
    field_options: handleInitialFieldOptions(),
    field_required: data.cloneField.field_validation.required[0] === "true",
    field_required_msg: data.cloneField.field_validation.required[1] || "",
    field_conditional: handleIsConditional(),
    field_conditional_key: handleConditionalData("key"),
    field_conditional_value: handleConditionalData("value"),
    field_number_min: Number(data.cloneField.field_validation.number_min) || 0,
    field_number_max: Number(data.cloneField.field_validation.number_max) || 1,
  }
}
